import { getIpAddress } from "./getIpAddress";

const getCookie = (name) => {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : '';
};

export const getTrackingData = async () => {
  const hubspotutk = getCookie('hubspotutk'); // HubSpot user token
  const initialLandingPage = getCookie('_uc_initial_landing_page'); // Get the cookie value
  console.log('initialLandingPage', initialLandingPage)
  const pageUri = window.location.href;
  console.log('pageUri', pageUri);
  const ipAddress = await getIpAddress();

  return { hubspotutk, initialLandingPage, pageUri, ipAddress };
};
